import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ProfileCard from "./ProfileCard";

import { useGetAuthRoleUserCounters } from "../../hooks/useOfClient"
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { Card, Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';

const ClientProfileCards = (props) => {
    const { t } = useTranslation();

    const clientId = (props.clientId !== null && props.clientId !== undefined) ? props.clientId : null;
    const productId = (props.productId !== null && props.productId !== undefined) ? props.productId : null;

    const [authRoleUserCounters, setAuthRoleUserCounters] = useState(null);
    useGetAuthRoleUserCounters(clientId, productId, authRoleUserCounters, setAuthRoleUserCounters);

    const myAwesomeArray = [1, 2, 3, 4]

    return (
        <>
        { authRoleUserCounters?.map((item, index) => 
            <ProfileCard key={index} clientId={clientId} counter={ item.counter } name={ item.name } totalLabel={t('data-lang-lbl-totalusers')} />
        )}
        { !authRoleUserCounters &&
            <Row>
            {myAwesomeArray.map((item, index) => 
                <Col key={index}>
                    <Card>
                        <Shimmer
                            customElementsGroup={
                                <div style={{ display: 'flex' }}>
                                    <ShimmerElementsGroup
                                        flexWrap
                                        width="100%"
                                        shimmerElements={[
                                            { type: ShimmerElementType.line, width: '25%', height: 10, verticalAlign: 'bottom' },
                                            { type: ShimmerElementType.gap, width: '75%', height: 25 },
                                            { type: ShimmerElementType.gap, width: '100%', height: 25 },
                                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                                            { type: ShimmerElementType.line, width: '100%', height: 10 },
                                        ]}
                                    />
                                </div>
                            }
                            styles={{
                                root: {
                                    width:"100%",
                                    height:"150px",
                                    backgroundColor: "white"}
                                }
                            }
                            className="pt-4"
                            isDataLoaded={authRoleUserCounters !== null}>
                        </Shimmer>
                    </Card>
                </Col>
            )}
            </Row>
        }
        </>
    );
};
ClientProfileCards.propTypes = {
    clientId: PropTypes.string.isRequired,
    productId: PropTypes.string.isRequired,
};
export default ClientProfileCards;